import React from 'react';
import { AvatarCircle, Subtitle } from '@/components/atoms';
import { RightArea, SubTitleArea, Wrapper } from './InsuranceListItem.styled';
import { IInsuranceItem } from '@/types';

const InsuranceListItem = (props: IInsuranceItem) => {
  const { insuName, desc1, desc2, licenseNo1, compLogoImgUrl, onClick } = props;

  return (
    <Wrapper onClick={onClick}>
      <AvatarCircle src={compLogoImgUrl} alt="test" />
      <RightArea className="text-area">
        <Subtitle level={4} color="gray-800" whiteSpaceWrap>
          {insuName}
        </Subtitle>
        <SubTitleArea>
          <Subtitle level={6} whiteSpaceWrap>
            {desc1}
          </Subtitle>
          <Subtitle level={6} color="primary-100" whiteSpaceWrap>
            {desc2}
          </Subtitle>
        </SubTitleArea>
        <Subtitle level={9} color="gray-500" whiteSpaceWrap>
          {licenseNo1}
        </Subtitle>
      </RightArea>
    </Wrapper>
  );
};

export default React.memo(InsuranceListItem);
